import {
  GET_TESTS,
  GET_ALL_QUESTIONS,
  REMOVE_SINGLE_QUESTION,
  ADD_SINGLE_QUESTION,
  MINI_GAMES_LIST,
  CREATED_QUIZ,
  REMOVE_QUIZ,
  GET_GUIZ_BY_ID,
  SET_ACTIVE_QUIZ_ID,
  GET_COMMENTS_BY_ID,
  GET_QUIZ_TICKET_LIST,
  REMOVE_SINGLE_TICKET,
  GET_KEYS,
  KEYS_TOTAL_COUNT,
  KEYS_CURRENT_PAGE,
  REMOVE_KEY,
  GET_ANSWER,
  GET_SCORES,
  SCORES_TOTAL_COUNT,
  SCORES_CURRENT_PAGE,
  REMOVE_SCORE,
  TESTS_CURRENT_PAGE,
  TESTS_TOTAL_PAGES,
  GET_COINS,
  COINS_CURRENT_PAGE,
  COINS_TOTAL_COUNT,
  GET_QUIZ_CHEATS,
  QUIZ_CHEATS_CURRENT_PAGE,
  QUIZ_CHEATS_TOTAL_PAGES,
  GET_WORDS,
  WORDS_TOTAL_COUNT,
  WORDS_CURRENT_PAGE,
  REMOVE_WORD,
  GET_PARTICIPANTS,
  PARTICIPANTS_TOTAL_COUNT,
  PARTICIPANTS_CURRENT_PAGE,
  GET_VOWS,
  VOWS_CURRENT_PAGE,
  VOWS_TOTAL_COUNT,
  REMOVE_VOW,
  GET_WGEVENTS,
  WGEVENTS_TOTAL_COUNT,
  WGEVENTS_CURRENT_PAGE,
  REMOVE_WGEVENT,
  GET_ALL_MARATHON_EVENTS,
  MARATHON_EVENTS_CURRENT_PAGE,
  MARATHON_EVENTS_TOTAL_PAGES,
  GET_MARATHON_EVENT_BY_ID,
  GET_MARATHON_QUESTIONS_BY_ID,
  ADD_MARATHON_QUESTION,
  UPDATE_MARATHON_QUESTION,
  REMOVE_MARATHON_QUESTION,
  GET_MARATHON_TICKET_LIST,
  MARATHON_TICKET_LIST_CURRENT_PAGE,
  MARATHON_TICKET_LIST_TOTAL_PAGES,
  REMOVE_MARATHON_SINGLE_TICKET,
  GET_MARATHON_ANSWER,
  GET_MARATHON_SCORES,
  MARATHON_SCORES_CURRENT_PAGE,
  MARATHON_SCORES_TOTAL_PAGES,
  UPDATE_MARATHON_SCORE,
} from "../../@jumbo/constants/ActionTypes";

export const setAllTests = (tests) => {
  return (dispatch) => {
    dispatch({
      type: GET_TESTS,
      payload: tests,
    });
  };
};
export const setTestsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: TESTS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};
export const setTestsTotalPage = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: TESTS_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};
export const setAllQuestions = (questions) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_QUESTIONS,
      payload: questions,
    });
  };
};
export const removeQustion = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_QUESTION,
      payload: id,
    });
  };
};
export const removeQuiz = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_QUIZ,
      payload: id,
    });
  };
};
export const addQustion = (question) => {
  return (dispatch) => {
    dispatch({
      type: ADD_SINGLE_QUESTION,
      payload: question,
    });
  };
};
export const setMiniGamesList = (miniGamesList) => {
  return (dispatch) => {
    dispatch({
      type: MINI_GAMES_LIST,
      payload: miniGamesList,
    });
  };
};
export const setCreatedQuiz = (createdQuiz) => {
  return (dispatch) => {
    dispatch({
      type: CREATED_QUIZ,
      payload: createdQuiz,
    });
  };
};
export const setSingleQuiz = (quiz) => {
  return (dispatch) => {
    dispatch({
      type: GET_GUIZ_BY_ID,
      payload: quiz,
    });
  };
};
export const setActiveQuizId = (quizId) => {
  return (dispatch) => {
    dispatch({
      type: SET_ACTIVE_QUIZ_ID,
      payload: quizId,
    });
  };
};

export const setCommentsById = (comments) => {
  return (dispatch) => {
    dispatch({
      type: GET_COMMENTS_BY_ID,
      payload: comments,
    });
  };
};

export const setQuizTicketList = (quizTicketList) => {
  return (dispatch) => {
    dispatch({
      type: GET_QUIZ_TICKET_LIST,
      payload: quizTicketList,
    });
  };
};

export const removeSingleTicketById = (ticketId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_TICKET,
      payload: ticketId,
    });
  };
};

export const setKeys = (keys) => {
  return (dispatch) => {
    dispatch({
      type: GET_KEYS,
      payload: keys,
    });
  };
};

export const setKeysCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: KEYS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setKeysTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: KEYS_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const removeKeyById = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_KEY,
      payload: id,
    });
  };
};

export const getAnswer = (answer) => {
  return (dispatch) => {
    dispatch({
      type: GET_ANSWER,
      payload: answer,
    });
  };
};

export const setScores = (scores) => {
  return (dispatch) => {
    dispatch({
      type: GET_SCORES,
      payload: scores,
    });
  };
};

export const setScoresCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: SCORES_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setScoresTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: SCORES_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const removeScoreById = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SCORE,
      payload: id,
    });
  };
};

export const setCoins = (coins) => {
  return (dispatch) => {
    dispatch({
      type: GET_COINS,
      payload: coins,
    });
  };
};

export const setCoinsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: COINS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setCoinsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: COINS_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const setQuizCheats = (cheats) => {
  return (dispatch) => {
    dispatch({
      type: GET_QUIZ_CHEATS,
      payload: cheats,
    });
  };
};

export const setQuizCheatsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: QUIZ_CHEATS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setQuizCheatsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: QUIZ_CHEATS_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};

export const setWords = (words) => {
  return (dispatch) => {
    dispatch({
      type: GET_WORDS,
      payload: words,
    });
  };
};

export const setWordsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: WORDS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setWordsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: WORDS_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const removeWordById = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_WORD,
      payload: id,
    });
  };
};

export const setParticipants = (participants) => {
  return (dispatch) => {
    dispatch({
      type: GET_PARTICIPANTS,
      payload: participants,
    });
  };
};

export const setParticipantsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: PARTICIPANTS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setParticipantsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: PARTICIPANTS_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const setVows = (vows) => {
  return (dispatch) => {
    dispatch({
      type: GET_VOWS,
      payload: vows,
    });
  };
};

export const setVowsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: VOWS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setVowsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: VOWS_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const removeVowById = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_VOW,
      payload: id,
    });
  };
};

export const setWGEvents = (wgevents) => {
  return (dispatch) => {
    dispatch({
      type: GET_WGEVENTS,
      payload: wgevents,
    });
  };
};

export const setWGEventsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: WGEVENTS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setWGEventsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: WGEVENTS_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const removeWGEventById = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_WGEVENT,
      payload: id,
    });
  };
};

export const setAllMarathonEvents = (events) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_MARATHON_EVENTS,
      payload: events,
    });
  };
};

export const setMarathonEventsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: MARATHON_EVENTS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setMarathonEventsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: MARATHON_EVENTS_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};

export const setMarathonEventById = (event) => {
  return (dispatch) => {
    dispatch({
      type: GET_MARATHON_EVENT_BY_ID,
      payload: event,
    });
  };
};

export const setMarathonQuestionsById = (questions) => {
  return (dispatch) => {
    dispatch({
      type: GET_MARATHON_QUESTIONS_BY_ID,
      payload: questions,
    });
  };
};

export const addMarathonQuestionToList = (question) => {
  return (dispatch) => {
    dispatch({
      type: ADD_MARATHON_QUESTION,
      payload: question,
    });
  };
};

export const updateMarathonQuestionInList = (id, question) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_MARATHON_QUESTION,
      payload: { id, question },
    });
  };
};

export const removeMarathonQuestionFromList = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_MARATHON_QUESTION,
      payload: id,
    });
  };
};

export const setMarathonTicketList = (marathonTicketList) => {
  return (dispatch) => {
    dispatch({
      type: GET_MARATHON_TICKET_LIST,
      payload: marathonTicketList,
    });
  };
};

export const setMarathonTicketListCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: MARATHON_TICKET_LIST_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setMarathonTicketListTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: MARATHON_TICKET_LIST_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};

export const removeMarathonSingleTicket = (ticketId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_MARATHON_SINGLE_TICKET,
      payload: ticketId,
    });
  };
};

export const setMarathonAnswer = (answer) => {
  return (dispatch) => {
    dispatch({
      type: GET_MARATHON_ANSWER,
      payload: answer,
    });
  };
};
export const setMarathonScores = (scores) => {
  return (dispatch) => {
    dispatch({
      type: GET_MARATHON_SCORES,
      payload: scores,
    });
  };
};

export const setMarathonScoresCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: MARATHON_SCORES_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setMarathonScoresTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: MARATHON_SCORES_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};
export const updateMarathonScoreInList = (id, score) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_MARATHON_SCORE,
      payload: { id, score },
    });
  };
};
